module.exports = __webpack_public_path__ + "img/teeth_direction.207a3d49.png";